export default {"id":"e90aadca","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}